import SitewideModal from './components/SitewideModal';


class SitewideModalLoader {
    constructor(){ 
        let modalHandler = new SitewideModal();
        modalHandler.render();
    }
}

export default new SitewideModalLoader();



// WEBPACK FOOTER //
// ./react-app-src/sitewideModal/SitewideModalLoader.js